/** Channels per group: a TV horizontal page (grid + selector), and a web selector pill. */
const EPG_TV_CHANNELS_PER_PAGE = 3;

export default EPG_TV_CHANNELS_PER_PAGE;
